import React, {Component} from 'react'
import locale from '../locale'
import { Table } from 'components/UI'
import getStudentClass from 'controllers/student/getStudentClass'
import moment from 'moment'
import Tooltip from 'react-tooltip';

class pastClassTable extends Component{
  constructor(props){
    super(props)

    this.state = {
      classList: [],
      fetching: true,
    }
  }


  componentWillReceiveProps({classList}){
    if(classList){
      this.setState({classList: classList, fetching: false})
    }
  }

  render(){
    const {showTable} = this.props
    let {classList, fetching} = this.state

    const fields = [{
      name: 'className',
      title: __('Class', locale),
      getTdProps: ({tbodyData})=>{
        return {
          style: {
            width: "35%"
          }
        }
      },
    }, {
      name: 'total_counted_amount',
      title: __('Attended', locale),
      getTdProps: ({tbodyData})=>{
        return {
          style: {
            width: "10%"
          }
        }
      },
      getTdContent: ({ trData: classInfo })=>{
        return classInfo.check_in_statistics.total_counted_amount
      },
    }, {
      name: 'total_absent_amount',
      title: __('Unattended', locale),
      getTdProps: ({tbodyData})=>{
        return {
          style: {
            width: "10%"
          }
        }
      },
      getTdContent: ({ trData: classInfo })=>{
        return classInfo.check_in_statistics.total_absent_amount
      },
    }, {
      name: 'class status',
      title: __('Class Status', locale),
      getTdProps: ({tbodyData})=>{
        return {
          style: {
            width: "20%"
          }
        }
      },
      getTdContent: ({ trData: classInfo })=>{
        if(classInfo.feeType == 0){
          return classInfo.consumed_and_purchased.paidEndDate ? moment(classInfo.consumed_and_purchased.paidEndDate).format(__('MMM DD, YYYY', locale)) : ''
        } else if(classInfo.feeType == 1){
          return classInfo.consumed_and_purchased.usedTotalQuantity + '/' + classInfo.consumed_and_purchased.paidTotalQuantity + ' ' + __('', locale)
        } else if(classInfo.feeType == 2){
          return classInfo.consumed_and_purchased.usedTotalQuantity + '/' + classInfo.consumed_and_purchased.paidTotalQuantity + ' ' + __('Hour', locale)
        }
      },
    },{
      name: 'tuition_consumption',
      title: __('Used/Paid', locale),
      getTdProps: ({tbodyData}) => {
        return {
          style: {
            width: "20%"
          }
        }
      },
      getTdContent: ({ trData: classInfo }) => {
        const currency = this.props.schoolDetail.currency
        const tuition_consumption = classInfo.consumed_and_purchased.tuition_consumption
        const paidTotalFee = classInfo.consumed_and_purchased.paidTotalFee
        const discountAmount = classInfo.consumed_and_purchased.total_discount_amount

        if(classInfo && tuition_consumption !== null){
          if(discountAmount > 0){
            return (
              <div>
                {tuition_consumption + ' / ' + paidTotalFee + ' ' +  currency}
                <i className='fa icon-tag' data-tip data-for={toString(classInfo.classID)}></i>
                <Tooltip
                  id={toString(classInfo.classID)}
                  effect='solid'
                  place='bottom'
                  type='info'
                  getContent={()=> { return __('Discounted', locale) + ' ' + discountAmount + ' ' + currency; }}
                />
              </div>
            )
          } else {
            return (<div>{tuition_consumption + ' / ' + paidTotalFee + ' ' +  currency}</div>)
          }
        } else{
          return (<div />)
        }
      },
    }]

    if(classList.length == 0){
      return(
        <div />
      )
    }

    if(showTable){
      return(
        <Table
          data={classList}
          fields={fields}
          className='pastClassTable'
          settingThTitle={' '}
          settingWidth={'15%'}
          settings={''}
          useMultiSelection={false}
          oneSettingPerRow={false}
          fetching={fetching}
          hideDropdownCaret={true}
          usePagination={false}

          dropdownGuideWidth={160}
          dropdownGuideHeight={228}
        />
      )
    } else {
      return(
        <div />
      )
    }

  }
}


export default pastClassTable



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/Tables/pastClassTable.js